<!-- Start Feedback Area -->
<section class="feedback-area">
    <div class="container">
        <div class="section-title">
            <h2>Trusted by over 250,000 business owners</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        </div>
    </div>

    <div class="feedback-shape"><img src="assets/img/white-shape2.png" alt="image"></div>
    <div class="shape-rectangle"><img src="assets/img/shape/1.png" alt="image"></div>
</section>
<!-- End Feedback Area -->